import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=ebba318a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=ebba318a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebba318a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ebba318a')) {
      api.createRecord('ebba318a', component.options)
    } else {
      api.reload('ebba318a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=ebba318a&scoped=true&", function () {
      api.rerender('ebba318a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Qwj3gFBQBKot/JS/comp/GuestBox.vue"
export default component.exports